module.exports = __webpack_public_path__ + "img/1512809072.5fcdba61.jpg";